import { KeyboardArrowDown as KeyboardArrowDownIcon } from '@mui/icons-material'
import { MenuItem, Select, SelectChangeEvent } from '@mui/material'
import cn from 'classnames'
import { useTranslations } from 'next-intl'
import { ComponentProps } from 'react'
import { useSortBy, UseSortByProps } from 'react-instantsearch'

type SearchSortByProps = ComponentProps<'div'> & {
  items: UseSortByProps['items']
}

export function SearchSortBy({
  items,
  className,
  ...props
}: SearchSortByProps) {
  const { currentRefinement, options, refine, canRefine } = useSortBy({
    items,
  })
  const t = useTranslations('SearchSortBy')

  const handleChange = (event: SelectChangeEvent) => {
    refine(event.target.value)
  }

  if (!canRefine) {
    return null
  }

  return (
    <div {...props} className={cn('flex items-center gap-4', className)}>
      <label
        htmlFor="sort-by"
        className="shrink-0 text-sm font-medium text-mydra-black"
      >
        {t('sort_by')}
      </label>

      <Select
        id="sort-by"
        value={currentRefinement}
        onChange={handleChange}
        IconComponent={KeyboardArrowDownIcon}
        classes={{
          root: cn('rounded-lg shrink-0'),
          select: cn(
            'py-2',
            'text-sm font-medium text-mydra-black',
            'font-inherit'
          ),
          icon: cn('text-mydra-black'),
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            className={cn('text-sm font-medium text-mydra-black')}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </div>
  )
}
